import { render } from "./CardEnvioAvaliacoes.vue?vue&type=template&id=9f738a32&scoped=true"
import script from "./CardEnvioAvaliacoes.vue?vue&type=script&lang=js"
export * from "./CardEnvioAvaliacoes.vue?vue&type=script&lang=js"

import "./CardEnvioAvaliacoes.vue?vue&type=style&index=0&id=9f738a32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f738a32"]])

export default __exports__